import type { LoggerScope } from '~/main/utils/logger';

export enum SUPPORTED_LANGUAGES {
  DEFAULT = 'default',
  ENGLISH = 'en',
  FRANCAIS = 'fr',
  DEUTSCH = 'de',
  NEDERLANDS = 'nl',
  ESPANOL = 'es',
}

export interface PrintSettings {
  isCustomized: boolean;
  isDithered: boolean;
  brightness: number;
}

export interface HubState {
  hubBackendEnvironmentUrl: string | null;
  enabledLoggerScopes: LoggerScope[] | '*' | 'none';
  isLaunchOnStartup: boolean;
  isAutoUpdatesEnabled: boolean;
  cashDrawerCable: number;
  allowNotifications: boolean;
  language: SUPPORTED_LANGUAGES;
  isFileLoggerEnabled: boolean;
  logo: string | undefined;
  printSettings: PrintSettings;
  isLabelPrinterResetting: boolean;
}
